@if (parentForm && requestType) {
  <form [formGroup]="parentForm" class="flex flex-col w-full">
    <section class="flex flex-col overflow-auto p-30 gap-y-30">
      <!-- Method -->
      <!-- Required field -->
      <div class="flex flex-col gap-y-10">
        <div class="flex flex-row items-center gap-x-5">
          <label class="text-base font-bold text-gray-dark required-label">Please choose a
          {{requestTypeLabel}} method</label>
          @if (requestType === requestTypeEnum.contribution) {
            <mat-icon class="mi-18 text-mint-dark" svgIcon="information" matTooltip="Only ACH is supported at this time"
              matTooltipPosition="after"
              matTooltipClass="text-sm border rounded-t rounded-b border-mint-lighter bg-mint-lightest text-gray-dark">
            </mat-icon>
          }
        </div>
        <div class="flex flex-col gap-y-5">
          <mat-select formControlName="deliveryMethod" [ngStyle]="{'pointer-events': requestType === requestTypeEnum.contribution ? 'none' : '', 'opacity': requestType === requestTypeEnum.contribution === true ? '0.5' : '1.0'}"
            (selectionChange)="updateDeliveryMethod(parentForm.value.deliveryMethod)" class="select" required>
            @for (option of deliveryMethodList; track option) {
              <mat-option [value]="option.value">
                {{option.name}}
              </mat-option>
            }
          </mat-select>          
          @if (parentForm.controls.deliveryMethod.touched && parentForm.controls.deliveryMethod.errors) {
            <span
              class="w-full text-xs -mt-15 text-red">
              @if (parentForm.controls.deliveryMethod.hasError('required')) {
                <span>This field is required.</span>
              }
            </span>
          }
        </div>
      
        @if (displayDeliveryInstructions && (filteredStandingInstructions === undefined || filteredStandingInstructions.length === 0))
        {           
           <!-- <app-message-notification panelType="alert" [showPanelIcon]=false>
            <div>
              <strong>No Standing Authorization on account for this selection.</strong>
              <br />
                In order to establish a new transfer/payment, please submit the necessary custodial paperwork.         
              <br />
              <a class="flex-row" href="api/sso/schwab?destination=D_DASH" target="_blank" rel="noopener"
                aria-label="Schwab Advisor Center">               
                <span class="acm-portal-nav-label">Go to Schwab Advisor Center</span>
              </a>
            </div>                 
          </app-message-notification>-->
          <div class="flex items-center text-sm text-orange">
            <div>
              <strong>No Standing Authorization on account for this selection.</strong>
              <br />
                In order to establish a new transfer/payment, please submit the necessary custodial paperwork.     
              <br />
              <a class="flex-row" href="api/sso/schwab?destination=D_DASH" target="_blank" rel="noopener"
                aria-label="Schwab Advisor Center">               
                <span class="acm-portal-nav-label">Go to Schwab Advisor Center</span>
              </a>
            </div>    
          </div>
        }
        @else if (displayDeliveryInstructions) {                      
          <mat-select formControlName="standingInstruction" (selectionChange)="updateDeliveryInstruction(parentForm.value.standingInstruction)" placeholder="Select bank account"
            class="select" required>
            @for (option of filteredStandingInstructions; track option) {
              <mat-option [value]="option">
                {{option.displayValue}}
              </mat-option>
            }
        </mat-select>
        }

        @if (displayDeliveryInstructions && parentForm.value.standingInstruction && !parentForm.value.standingInstruction.hasIaAuthority)
        {           
           <!-- <app-message-notification panelType="alert" [showPanelIcon]=false>
            <div>
              <strong>No Standing Authorization on account for this selection.</strong>
              <br />
               In order to establish a new transfer/payment, please submit the necessary custodial paperwork.       
              <br />
              <a class="flex-row" href="api/sso/schwab?destination=D_DASH" target="_blank" rel="noopener"
                aria-label="Schwab Advisor Center">               
                <span class="acm-portal-nav-label">Go to Schwab Advisor Center</span>
              </a>
            </div>                 
          </app-message-notification>-->
          <div class="flex items-center text-sm text-orange">
            <div>
              <strong>No Standing Authorization on account for this selection.</strong>
              <br />
               In order to establish a new transfer/payment, please submit the necessary custodial paperwork.    
              <br />
              <a class="flex-row" href="api/sso/schwab?destination=D_DASH" target="_blank" rel="noopener"
                aria-label="Schwab Advisor Center">               
                <span class="acm-portal-nav-label">Go to Schwab Advisor Center</span>
              </a>
            </div>    
          </div>
        }

        @if (parentForm.controls.isOvernightCheckDelivery.enabled) {
          <mat-checkbox class="is-mint-checkbox" formControlName="isOvernightCheckDelivery">Overnight Delivery?</mat-checkbox>
        }
        <!-- @if (parentForm.controls.wireDeliveryOptionId.enabled) {
          <div class="w-1/2 flex flex-col gap-y-5">
            <mat-select class="select" placeholder="Choose whom to transfer to" formControlName="wireDeliveryOptionId">
              @for (option of transferRecipientList; track option) {
                <mat-option [value]="option.value">{{option.name}}</mat-option>
              }
            </mat-select>
            @if (parentForm.controls.wireDeliveryOptionId.touched && parentForm.controls.wireDeliveryOptionId.errors) {
              <span
                class="w-full text-xs text-red">
                @if (parentForm.controls.wireDeliveryOptionId.hasError('required')) {
                  <span>This field is required.</span>
                }
              </span>
            }
          </div>
        } -->
        <!-- @if (parentForm.value.wireDeliveryOptionId === transferRecipientEnum.thirdParty) {
          <div class="flex flex-row gap-x-10">
            <mat-icon class="mi-18 text-mint-dark flex-shrink-0" svgIcon="information"></mat-icon>
            <span class="text-xs">Third party wire transfers require an applicable wire transfer instructions form that is signed by the client. Please  attach the applicable form with client signature.
              <br />
              <a class="flex-row" href="api/sso/schwab?destination=D_DASH" target="_blank" rel="noopener"
                aria-label="Schwab Advisor Center">               
                <span class="acm-portal-nav-label">Go to Schwab Advisor Center</span>
              </a>
            </span>            
          </div>
        } -->
        <!-- @if (parentForm.controls.journalCashRecipientAccountNumber.enabled) {
          <div class="w-1/2 flex flex-col gap-y-5">
            <input class="input" formControlName="journalCashRecipientAccountNumber" placeholder="Enter account number" />
            @if (parentForm.controls.journalCashRecipientAccountNumber.touched && parentForm.controls.journalCashRecipientAccountNumber.errors) {
              <span class="w-full text-xs text-red">
                @if (parentForm.controls.journalCashRecipientAccountNumber.hasError('required')) {
                  <span>This field is required.</span>
                }
              </span>
            }
          </div>
        } -->
      </div>
      <!-- Frequency -->
      <!-- Required field -->
      @if (requestType !== requestTypeEnum.closeAccount) {
        <div class="flex flex-col gap-y-10" >
          <label class="text-base font-bold text-gray-dark required-label" for="tradeFrequency">How often is the {{requestTypeLabel}} made?</label>
          <div class="flex flex-col gap-y-10">
            <mat-select formControlName="tradeFrequency" (selectionChange)="updateDeliveryFrequency(parentForm.value.tradeFrequency)" class="select" required>
              @for (option of tradeFrequencyList; track option) {
                <mat-option [value]="option.value">
                  {{option.name}}
                </mat-option>
              }
            </mat-select>
            @if (parentForm.controls.tradeFrequency.touched && parentForm.controls.tradeFrequency.errors) {
              <span
                class="w-full text-xs text-red">
                @if (parentForm.controls.tradeFrequency.hasError('required')) {
                  <span>This field is
                  required.</span>
                }
              </span>
            }
          </div>
        </div>
      }
      <!-- Date to initiate -->
      @if (parentForm.controls.initiationDate.enabled) {
        <div class="flex flex-col gap-y-10">
          <label class="text-base font-bold text-gray-dark required-label" for="initiationDate">When should
          the {{requestTypeLabel}} initiate?</label>
          <div class="datepicker-input-container">
            <input [matDatepicker]="picker" class="datepicker-input" [min]="minDate" formControlName="initiationDate" (click)="picker.open()" readonly
              placeholder="mm/dd/yyyy">
              <mat-icon class="datepicker-icon" svgIcon="calendar" matDatepickerToggleIcon></mat-icon>
              <mat-datepicker #picker color="accent"></mat-datepicker>
            </div>
            @if (parentForm.controls.initiationDate.touched) {
              <span
                class="w-full text-xs -mt-15 text-red">
              @if (parentForm.controls.initiationDate.hasError('required')) {
                <span>This field is required.</span>
              }
            </span>
          }
        </div>
      }
      <!-- File upload -->
      <!-- Optional field -->
      <div class="flex flex-col gap-y-10">
        <label class="text-base font-bold text-gray-dark required-label" for="contribution-uploads">Please upload any
        required documents below</label>
        @if (parentForm.value) {
          <app-file-dropper (fileChangeEvent)="uploadFiles($event)" [value]="parentForm.value.files"></app-file-dropper>
        }
      </div>
    </section>
  </form>
}